module.exports = __webpack_public_path__ + "img/Shaman-troll-m-70.1b097b4f.gif";